import { useCallback, useEffect, useRef, useState } from 'react';

export const useTransientFlag = (durationMs = 3000) => {
  const [visible, setVisible] = useState(false);
  const timerRef = useRef<ReturnType<typeof setTimeout>>();

  const flash = useCallback(() => {
    setVisible(true);

    if (timerRef.current !== undefined) {
      clearTimeout(timerRef.current);
    }

    timerRef.current = setTimeout(() => setVisible(false), durationMs);
  }, [durationMs]);

  useEffect(
    () => () => {
      if (timerRef.current !== undefined) {
        clearTimeout(timerRef.current);
      }
    },
    []
  );

  return [visible, flash] as const;
};
